import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import countrySlice from "../features/country/countrySlice";
import userSlice from "../features/user/userSlice";
import stateSlice from "../features/state/stateSlice";
import citySlice from "../features/city/citySlice";
import regionSlice from "../features/region/regionSlice";
import specialityTypeSlice from "../features/specialitytype/specialityTypeSlice";
import sectorSlice from "../features/sector/sectorSlice";
import hotelBlockSlice from "../features/hotelblock/hotelBlockSlice";
import roomTypeSlice from "../features/roomtype/roomTypeSlice";
import vendorTypeSlice from "../features/vendortype/vendorTypeSlice";
import vendorSlice from "../features/vendor/vendorSlice";
import mealtypeSlice from "../features/mealtype/mealtypeSlice";
import nationalitySlice from "../features/nationality/nationalitySlice";
import sectorCitySlice from "../features/sectorcity/sectorCitySlice";
import termsAndConditionSlice from "../features/termsandcondition/termsAndConditionSlice";
import tourSlice from "../features/tour/tourSlice";
import companySlice from "../features/company/companySlice";
import gstSlice from "../features/gst/gstSlice";
import hotelSlice from "../features/hotel/hotelSlice";
import currencySlice from "../features/currency/currencySlice";
import vehicleSharingPaxSlice from "../features/vehiclesharingpax/vehicleSharingPaxSlice";
import airlineblockSlice from "../features/airlineblock/airlineblockSlice";
import airlineSlice from "../features/airline/airlineSlice";
import airlineclassSlice from "../features/airlineclass/airlineclassSlice";
import flightplaceSlice from "../features/flightplace/flightplaceSlice";
import airportSlice from "../features/airport/airportSlice";
import paxTypeSlice from "../features/paxtype/paxTypeSlice";
import routeSlice from "../features/route/routeSlice";
import branchSlice from "../features/branch/branchSlice";
import foodOptionSlice from "../features/foodoption/foodOptionSlice";
import groupRouteSlice from "../features/grouproute/groupRouteSlice";
import tourBookingSlice from "../features/tourbooking/tourBookingSlice";
import hotelBookingSlice from "../features/hotelvoucher/hotelVoucherSlice";
import paymentReceiptSlice from "../features/paymentreceipt/paymentReceiptSlice";
import routeVoucherSlice from "../features/routevoucher/routeVoucherSlice";
import roomCategorySlice from "../features/roomcategory/roomCategorySlice";
import hotelMappingSlice from "../features/hotelmapping/hotelMappingSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import airlineVoucherSlice from "../features/airlinevoucher/airlineVoucherSlice";
import reportSlice from "../features/reports/reportSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import vehicletypeSlice from "../features/vehicletype/vehicletypeSlice";
import travelpurposeSlice from "../features/travelpurpose/travelpurposeSlice";
import employmentstatusSlice from "../features/employmentstatus/employmentstatusSlice";
import visaprocessingoptionSlice from "../features/visaprocessingoption/visaprocessingoptionSlice";
import additionalserviceSlice from "../features/additionalservice/additionalserviceSlice";
import sponsorshiptypeSlice from "../features/sponsorshiptype/sponsorshiptypeSlice";
import festivalsSlice from "../features/festival/festivalsSlice";
import cancellationpolicySlice from "../features/companypolicy/cancellationpolicySlice";
import leadsourceSlice from "../features/leadsource/leadsourceSlice";
import vehicleSlice from "../features/vehicle/vehicleSlice";
import itinearySlice from "../features/itinerary/itinearySlice";
import agentSlice from "../features/agent/agentSlice";
import itineraryfacilitySlice from "../features/ItineraryFacility/itineraryfacilitySlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import leadStageSlice from "../features/leadstage/leadStageSlice";
import quotationSlice from "../features/quotation/quotationSlice";
import integrationSlice from "../features/integrations/integrationSlice";
import leadSlice from "../features/lead/leadSlice";
import contactSlice from "../features/contact/contactSlice";
// import airlineBlockSlice from "../features/aitlineblock/airlineBlockSlice";
import FITBookingSlice from "../features/fitbooking/FITBookingSlice";
import sightseenSlice from "../features/sightseen/sightseenSlice";
import settingSlice from "../features/setting/settingSlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import serviceSlice from "../features/service/serviceSlice";
import faqSlice from "../features/faq/faqSlice";
import usefullinksSlice from "../features/usefullinks/usefullinksSlice";
import bannerSlice from "../features/banner/bannerSlice";
import brochureSlice from "../features/brochure/brochureSlice";
import adminsettingSlice from "../features/adminsetting/adminsettingSlice";
import organizationSlice from "../features/organization/organizationSlice";
import templateSlice from "../features/template/templateSlice";
import whatsappAutoTriggerSlice from "../features/whatsappautotrigger/whatsappAutoTriggerSlice";
import emailAutoTriggerSlice from "../features/emailautotrigger/emailAutoTriggerSlice";
import leadAssignSettingSlice from "../features/leadassignsetting/leadAssignSettingSlice";
import visacategorySlice from "../features/visacategory/visacategorySlice";
import tourserviceSlice from "../features/tourservice/tourserviceSlice";
import visagatewaySlice from "../features/visagateway/visagatewaySlice";
import documentSlice from "../features/document/documentSlice";
import visacountrySlice from "../features/visacountry/visacountrySlice";
import visaentrytypeSlice from "../features/visaentrytype/visaentrytypeSlice";
import clientLogoSlice from "../features/clientlogo/clientLogoSlice";
import webBranchSlice from "../features/webbranch/webBranchSlice";
import instagramStorySlice from "../features/instagramstory/instagramStorySlice";
import communitySlice from "../features/community/communitySlice";
import activitySlice from "../features/activity/activitySlice";
import weekendgatewaysSlice from "../features/weekendgatways/weekendgatewaysSlice";
import newsletterSlice from "../features/newsletter/newsletterSlice";
import couponcodeSlice from "../features/couponcode/couponcodeSlice";
import sectionSlice from "../features/section/sectionSlice";
import designationSlice from "../features/designation/designationSlice";
import careerSlice from "../features/career/careerSlice";
import bookingSlice from "../features/booking/bookingSlice";

const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    login: loginReducer,
    dialog: dialogSlice,
    drawer: drawerSlice,
    user: userSlice,
    country: countrySlice,
    state: stateSlice,
    city: citySlice,
    document: documentSlice,
    visacountry: visacountrySlice,
    region: regionSlice,
    specialityType: specialityTypeSlice,
    sector: sectorSlice,
    hotelBlock: hotelBlockSlice,
    vehicleType: vehicletypeSlice,
    travelpurpose: travelpurposeSlice,
    employmentstatus: employmentstatusSlice,
    sponsorshiptype: sponsorshiptypeSlice,
    visaprocessingOption: visaprocessingoptionSlice,
    additionalservice: additionalserviceSlice,
    leadsource: leadsourceSlice,
    festivals: festivalsSlice,
    cancellationpolicy: cancellationpolicySlice,
    vehicle: vehicleSlice,
    itineary: itinearySlice,
    itinearyfacility: itineraryfacilitySlice,
    agent: agentSlice,
    mealType: mealtypeSlice,
    roomType: roomTypeSlice,
    vendor: vendorSlice,
    vendorType: vendorTypeSlice,
    nationality: nationalitySlice,
    sectorCity: sectorCitySlice,
    termsandcondition: termsAndConditionSlice,
    tour: tourSlice,
    company: companySlice,
    hotel: hotelSlice,
    gst: gstSlice,
    currency: currencySlice,
    vehicleSharingPax: vehicleSharingPaxSlice,
    sightseen: sightseenSlice,
    airline: airlineSlice,
    airlineblock: airlineblockSlice,
    airlineclass: airlineclassSlice,
    flightplace: flightplaceSlice,
    airport: airportSlice,
    paxType: paxTypeSlice,
    route: routeSlice,
    branch: branchSlice,
    foodOption: foodOptionSlice,
    groupRoute: groupRouteSlice,
    tourBooking: tourBookingSlice,
    hotelVoucher: hotelBookingSlice,
    paymentReceipt: paymentReceiptSlice,
    routeVoucher: routeVoucherSlice,
    roomCategory: roomCategorySlice,
    hotelMapping: hotelMappingSlice,
    airlineVoucher: airlineVoucherSlice,
    reports: reportSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    pagination: paginationSlice,
    inquiry: inquirySlice,
    leadStage: leadStageSlice,
    quotation: quotationSlice,
    integration: integrationSlice,
    lead: leadSlice,
    contact: contactSlice,
    FITBooking: FITBookingSlice,

    setting: settingSlice,
    cms: cmsSlice,
    banner: bannerSlice,
    faq: faqSlice,
    service: serviceSlice,
    usefullinks: usefullinksSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    seotag: seotagSlice,
    brochure: brochureSlice,
    adminsetting: adminsettingSlice,
    organization: organizationSlice,
    template: templateSlice,
    whatsappAutoTrigger: whatsappAutoTriggerSlice,
    emailAutoTrigger: emailAutoTriggerSlice,
    leadAssignSetting: leadAssignSettingSlice,
    visacategory: visacategorySlice,
    tourservice: tourserviceSlice,
    visagateway: visagatewaySlice,
    visaentrytype: visaentrytypeSlice,
    clientLogo: clientLogoSlice,
    webBranch: webBranchSlice,
    instagramStory: instagramStorySlice,
    community: communitySlice,
    activity: activitySlice,
    weekendgateways: weekendgatewaysSlice,
    newsletter: newsletterSlice,
    couponcode: couponcodeSlice,
    section: sectionSlice,
    designation: designationSlice,
    career: careerSlice,
    booking: bookingSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
